import './LegalPage.css';

export default function LegalPageLayout({ title, updated, children }) {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <p className="legal-hero__tag">Yasal</p>
          <h1 className="legal-hero__title">{title}</h1>
          <p className="legal-hero__updated">Son güncelleme tarihi: {updated}</p>
        </div>
      </section>
      <section className="legal-body">
        <div className="container legal-prose">{children}</div>
      </section>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section className="legal-section">
      {title && <h2>{title}</h2>}
      {children}
    </section>
  );
}

export function LegalList({ items }) {
  return (
    <ul>
      {items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  );
}

export function LegalNote({ children }) {
  return <div className="legal-note">{children}</div>;
}
